import api from "./api";

// GET all users
export const getAllUsers = async () => {
    try {
        const response = await api.get("/api/auth");
        return response.data;
    } catch (error) {
        throw error;
    }
};

// GET a user by ID (with optional property population)
export const getUserById = async (id, populateProperties = false) => {
    try {
        const response = await api.get(`/api/auth/${id}`, {
            params: { populateProperties }, // Pass populateProperties as query param
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

// POST (Create) a new user
export const createUser = async (data) => {
    try {
        const response = await api.post("/api/auth", data);
        return response.data;
    } catch (error) {
        throw error;
    }
};

// PUT (Update) a user by ID
export const updateUser = async (id, data) => {
    try {
        const response = await api.put(`/api/auth/${id}`, data);
        return response.data;
    } catch (error) {
        throw error;
    }
};

// DELETE a user by ID
export const deleteUser = async (id) => {
    try {
        const response = await api.delete(`/api/auth/${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};




// POST (Login) a new user
export const loginUser = async (data) => {
    try {
        const response = await api.post("/api/auth/login", data);
        return response.data;
    } catch (error) {
        throw error;
    }
};




// POST (Login) a new user
export const verifyOtp = async (data) => {
    try {
        const response = await api.post("/api/auth/verify-otp", data);
        return response.data;
    } catch (error) {
        throw error;
    }
};